import { EMPTY_ARRAY } from '@/redux/selectors/pieveSelectors/constants.js';
import getThreadLastActivityTimestamp from '@/redux/selectors/pieveSelectors/lib/getThreadLastActivityTimestamp.js';
import getThreadParentId from '@/redux/selectors/pieveSelectors/lib/getThreadParentId.js';
import normalizeThreadType from '@/lib/threads/normalizeThreadType.js';

/* Thread types that are children of another thread WITHOUT being sub-agents of it — a step task and the
   Test window's chat hang off their workflow thread only to inherit sharing, access and archival. */
const NON_SUBAGENT_CHILD_THREAD_TYPES = new Set(['workflow_step', 'workflow_test']);

const getSubagentItemsForParentId = ({ threadMetaByIdValue, parentThreadId }) => {
  const normalizedParentId = String(parentThreadId || '').trim();

  if (!normalizedParentId) {
    return EMPTY_ARRAY;
  }

  return Object.values(threadMetaByIdValue || {})
    .filter((threadMeta) => {
      const threadId = String(threadMeta?.id || '').trim();
      const archivedAt = String(threadMeta?.archivedAt || threadMeta?.archived_at || '').trim();

      if (!threadId || archivedAt) {
        return false;
      }

      if (NON_SUBAGENT_CHILD_THREAD_TYPES.has(normalizeThreadType(threadMeta?.threadType || threadMeta?.thread_type))) {
        return false;
      }

      return getThreadParentId(threadMeta) === normalizedParentId;
    })
    .sort((left, right) => {
      return getThreadLastActivityTimestamp(right) - getThreadLastActivityTimestamp(left);
    });
};

export default getSubagentItemsForParentId;
